var render, staticRenderFns
import script from "./associated_customer_three.vue?vue&type=script&lang=js"
export * from "./associated_customer_three.vue?vue&type=script&lang=js"
import style0 from "./associated_customer_three.vue?vue&type=style&index=0&id=21fd9841&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21fd9841",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21fd9841')) {
      api.createRecord('21fd9841', component.options)
    } else {
      api.reload('21fd9841', component.options)
    }
    
  }
}
component.options.__file = "found/views/mdm/views/user_management/form/associated_customer/associated_customer_three.vue"
export default component.exports